import { render, staticRenderFns } from "./payoutCommission.vue?vue&type=template&id=4236d45f&scoped=true"
import script from "./payoutCommission.vue?vue&type=script&lang=js"
export * from "./payoutCommission.vue?vue&type=script&lang=js"
import style0 from "./payoutCommission.vue?vue&type=style&index=0&id=4236d45f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4236d45f",
  null
  
)

export default component.exports